import { useEffect } from 'react';
import config from '../config/config';
import EventDTO from '../models/event';

interface UseEventPixelOptions {
  trackPageView?: boolean;
  enabled?: boolean;
}

/**
 * Initializes the event-specific Meta Pixel so it receives all subsequent
 * fbq('track', …) calls alongside the base pixel.
 *
 * The fbq stub is created at module level by useBasePixel, so init runs
 * synchronously — no polling needed. This guarantees the event pixel is
 * registered before any tracking effects in the same component fire.
 */
const useEventPixel = (
  event: EventDTO | null | undefined,
  options: UseEventPixelOptions = {},
) => {
  const { trackPageView = false, enabled = true } = options;

  useEffect(() => {
    if (!enabled || !config.production || !event?.meta_pixel_id) {
      return;
    }

    const { fbq } = window;
    if (!fbq) {
      return;
    }

    fbq('set', 'autoConfig', false, event.meta_pixel_id);
    fbq('init', event.meta_pixel_id);

    if (trackPageView) {
      fbq('track', 'PageView');
    }
  }, [event?.meta_pixel_id, trackPageView, enabled]);
};

export default useEventPixel;
